<template>
    <div style="height: 340px">
        <v-row>
            <v-col class="py-0">
                <v-card class="pl-3 py-1" color="white">
                    <v-text-field
                        height="35px"
                        background-color="white"
                        hide-details
                        readonly
                        solo
                        flat
                    >
                        <template v-slot:prepend>
                            <v-fade-transition leave-absolute>
                                <v-icon>mdi-led-on</v-icon>
                            </v-fade-transition>
                        </template>
                        <template v-slot:append>
                            <v-fade-transition leave-absolute>
                                <div class="mt-1" v-if="!loading">
                                    <v-btn
                                        small
                                        depressed
                                        v-model="control.value"
                                        :color="control.value ? 'green accent-1' : 'grey lighten-3'" 
                                        @click="dialog1o()"
                                        >{{control.text}}
                                    </v-btn>
                                </div>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="accent"
                                ></v-progress-circular>
                            </v-fade-transition>
                        </template>
                    </v-text-field>
                    <p>Control</p>
                    <v-dialog v-model="open1" persistent width="400" class="align-center">
                        <template>
                            <v-card height="160">
                                    <v-toolbar :elevation="0" color="primary" dark>
                                        <v-toolbar-title>Confirm changes</v-toolbar-title>
                                    </v-toolbar>
                                    <v-form ref="form" class="text-center mt-3">
                                        Do you want to {{ msg }} control?
                                    </v-form>
                                    <div align="right" class="align-content-end mx-4 mt-3">
                                        <v-btn color="accent" 
                                            small
                                            class="white--text mx-2"
                                            @click="sendCommand('control')"
                                            >Confirm
                                        </v-btn>
                                        <v-btn color="danger" 
                                            small
                                            text
                                            @click="dialog1c()"
                                            >Cancel
                                        </v-btn>
                                    </div>
                            </v-card>
                        </template>
                    </v-dialog>
                </v-card>
            </v-col>
            <v-col class="py-0">
                <v-card class="pl-3 py-1" color="white">
                    <v-text-field
                        height="35px"
                        background-color="white"
                        hide-details
                        readonly
                        solo
                        flat
                    >
                        <template v-slot:prepend>
                            <v-fade-transition leave-absolute>
                                <v-icon class="ml-3">mdi-solar-panel-large</v-icon>
                            </v-fade-transition>
                        </template>
                        <template v-slot:append>
                            <v-fade-transition leave-absolute>
                                <div class="mt-1" v-if="!loading">
                                    <v-btn 
                                        small
                                        depressed
                                        v-model="fotocelda.value"
                                        :color="fotocelda.value ? 'green accent-1' : 'grey lighten-3'"
                                        @click="dialog2o()"
                                        >{{fotocelda.text}}
                                    </v-btn>
                                </div>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="accent"
                                ></v-progress-circular>
                            </v-fade-transition>
                        </template>
                    </v-text-field>
                    <p>Photocell</p>
                    <v-dialog v-model="open2" persistent width="400" class="align-center">
                        <template>
                            <v-card height="160">
                                    <v-toolbar :elevation="0" color="primary" dark>
                                        <v-toolbar-title>Confirm changes</v-toolbar-title>
                                    </v-toolbar>
                                    <v-form ref="form" class="text-center mt-3">
                                        Do you want to {{msg}} photocell?
                                    </v-form>
                                    <div align="right" class="align-content-end mx-4 mt-3">
                                        <v-btn color="accent" 
                                            small
                                            class="white--text mx-2"
                                            @click="sendCommand('fotocelda')"
                                            >Confirm
                                        </v-btn>
                                       <v-btn color="danger" 
                                            small 
                                            text
                                            @click="dialog2c()"
                                            >Cancel
                                        </v-btn>
                                    </div>
                            </v-card>
                        </template>
                    </v-dialog>
                </v-card>
            </v-col>
            <v-col cols="12" class="pb-2">
                <v-card height="232">
                    <v-list-item dense>
                        <v-list-item-avatar>
                            <v-icon>mdi-clock</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="ml-n1">
                            Schedule Type
                        </v-list-item-content> 
                        <v-list-item-icon class="d-flex">
                            <div class="mt-1 mr-n1" v-if="!loading">
                                <v-btn 
                                    small
                                    depressed
                                    color="grey lighten-3"
                                    @click="dialog5o()"
                                    v-model="suntime"
                                    >
                                   <v-icon v-if="suntime" class="mr-2">mdi-white-balance-sunny</v-icon>
                                   <v-icon v-else class="mr-2">mdi-account-clock</v-icon>
                                   {{textSuntime}}
                                </v-btn>
                            </div>
                            <v-progress-circular
                                v-else
                                indeterminate
                                color="accent"
                            ></v-progress-circular>
                            <v-dialog v-model="open5" persistent width="400" class="align-center">
                                <template>
                                    <v-card height="160">
                                            <v-toolbar :elevation="0" color="primary" dark>
                                                <v-toolbar-title>Confirm changes</v-toolbar-title>
                                            </v-toolbar>
                                            <v-form ref="form" class="text-center mt-3">
                                                Do you want to {{msg}} solar schedule?
                                            </v-form>
                                            <div align="right" class="align-content-end mx-4 mt-3">
                                                <v-btn color="accent" 
                                                    small
                                                    class="white--text mx-2"
                                                    @click="sendScheduleSun(suntime)"
                                                    >Confirm
                                                </v-btn>
                                                <v-btn color="danger" 
                                                    small 
                                                    text
                                                    @click="dialog5c()"
                                                    >Cancel
                                                </v-btn>
                                            </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </v-list-item-icon>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-card-text class="text-center d-flex py-9">
                        <div style="width: 50%" class="my-auto" v-if="on_schedule.hours">
                            <p @click="openMenuSchedule('on')"
                                class="my-0 subtitle-1 text-h6 font-weight-bold primary--text">
                                {{ this.suntime ? this.sunset_suntime_hours : this.on_schedule.hours }}:{{ this.suntime ? this.sunset_suntime_minutes : this.on_schedule.minutes }}
                            </p>
                            <p class="text-caption my-0">ON</p>
                            <div class="mt-1" v-if="!loading">
                                <v-btn 
                                    v-if="!suntime"
                                    small
                                    depressed
                                    v-model="on_schedule.status"
                                    :color="on_schedule.status ? 'green accent-1' : 'grey lighten-3'"
                                    :disabled="suntime" 
                                    @click="dialog3o()">
                                    {{on_schedule.text}}
                                </v-btn>
                            </div>
                            <v-progress-circular
                                v-else
                                indeterminate
                                color="accent"
                            ></v-progress-circular>
                            <v-dialog v-model="open3" persistent width="420" class="align-center">
                                <template>
                                    <v-card height="160">
                                            <v-toolbar :elevation="0" color="primary" dark>
                                                <v-toolbar-title>Confirm changes</v-toolbar-title>
                                            </v-toolbar>
                                            <v-form ref="form" class="text-center mt-3">
                                                Do you want to {{msg}} ON Schedule?
                                            </v-form>
                                            <div align="right" class="align-content-end mx-4 mt-3">
                                                <v-btn color="accent" 
                                                    small
                                                    class="white--text mx-2"
                                                    @click="confirmChangeON()"
                                                    >Confirm
                                                </v-btn>
                                                <v-btn color="danger" 
                                                    small
                                                    text
                                                    @click="dialog3c()"
                                                    >Cancel
                                                </v-btn>
                                            </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </div>
                        <div style="width: 50%" class="my-auto" v-else>
                            <p @click="openMenuSchedule('on')"
                                class="my-0 red--text text-caption">
                                {{ on_schedule.msg }}
                            </p>
                        </div>
                        <v-divider vertical></v-divider>
                        <div style="width: 50%" class="my-auto" v-if="off_schedule.hours">
                            <p @click="openMenuSchedule('off')" 
                                class="my-0 subtitle-1 text-h6 font-weight-bold primary--text">
                                {{ this.suntime ? this.sunrise_suntime_hours : this.off_schedule.hours }}:{{ this.suntime ? this.sunrise_suntime_minutes : this.off_schedule.minutes }}
                            </p>
                            <p class="text-caption my-0">OFF</p>
                            <div class="mt-1" v-if="!loading">
                                <v-btn 
                                    v-if="!suntime"
                                    small
                                    depressed
                                    v-model="off_schedule.status"
                                    :color="off_schedule.status ? 'green accent-1' : 'grey lighten-3'"
                                    :disabled="suntime" 
                                    @click="dialog4o()"
                                    >{{off_schedule.text}}
                                </v-btn>
                            </div>
                            <v-progress-circular
                                v-else
                                indeterminate
                                color="accent"
                            ></v-progress-circular>
                            <v-dialog v-model="open4" persistent width="420" class="align-center">
                                <template>
                                    <v-card height="160">
                                            <v-toolbar :elevation="0" color="primary" dark>
                                                <v-toolbar-title>Confirm changes</v-toolbar-title>
                                            </v-toolbar>
                                            <v-form ref="form" class="text-center mt-3">
                                                Do you want to {{msg}} OFF Schedule?
                                            </v-form>
                                            <div align="right" class="align-content-end mx-4 mt-3">
                                                <v-btn color="accent" 
                                                    small
                                                    class="white--text mx-2"
                                                    @click="confirmChangeOFF()"
                                                    >Confirm
                                                </v-btn>
                                                <v-btn color="danger" 
                                                    small
                                                    text
                                                    @click="dialog4c()"
                                                    >Cancel
                                                </v-btn>
                                            </div>
                                    </v-card>
                                </template>
                            </v-dialog>
                        </div>
                        <div style="width: 50%" class="my-auto" v-else>
                            <p @click="openMenuSchedule('off')"
                                class="my-0 red--text text-caption">
                                {{ off_schedule.msg }}
                            </p>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="schedule.menu" max-width="400px">
            <v-card>
                <v-card-text class="py-3">
                    <p class="subtitle-1 font-weight-bold primary--text"
                        >{{ schedule.type === 'on' ? 'ON' : 'OFF'}} Schedule
                        <span class="text-caption"
                            >(UTC Hour)
                        </span>
                    </p>
                    <p class="mb-1"
                        >Hour
                    </p>
                    <v-select
                        v-model="schedule.hours"
                        :items="Array.from(Array(24).keys())"
                        solo
                        outlined
                        flat
                    ></v-select>
                    <p class="mb-1">Minutes</p>
                    <v-select
                        v-model="schedule.minutes"
                        :items="Array.from(Array(60).keys())"
                        solo
                        outlined
                        flat
                    ></v-select>
                    <v-btn 
                        block color="accent" 
                        :disabled="!Number.isInteger(schedule.hours) || !Number.isInteger(schedule.minutes)" 
                        @click="dialogControlOpen()"
                        >Save
                    </v-btn>
                    <v-btn 
                        @click="cancelSchedule" 
                        block 
                        text 
                        color="danger"
                        class="mt-2"
                        >Cancel
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="openUp" persistent width="400" class="align-center">
            <template>
                <v-card height="160">
                        <v-toolbar :elevation="0" color="primary" dark>
                            <v-toolbar-title>Confirm changes</v-toolbar-title>
                        </v-toolbar>
                        <v-form ref="form" class="text-center mt-3">
                            Do you want to proceed with this change?
                        </v-form>
                        <div align="right" class="align-content-end mx-4 mt-3">
                            <v-btn color="accent" 
                                small
                                class="white--text mx-2"
                                @click="sendSchedule(schedule.type)" 
                                >Confirm
                            </v-btn>
                            <v-btn color="danger" 
                                small 
                                text
                                @click="dialogControlClose()"
                                >Cancel
                            </v-btn>
                        </div>
                </v-card>
            </template>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapState, mapActions }  from 'vuex'
import moment from 'moment'
import { Meter } from '../../api'
export default {
    name: 'control',
    props: ['meter'],
    computed: {
        ...mapState({
            location: state => state.user.location,
            sunrise_suntime_hours : state => state.user.sunrise_suntime_hours,
            sunrise_suntime_minutes: state => state.user.sunrise_suntime_minutes,
            sunset_suntime_hours: state => state.user.sunset_suntime_hours,
            sunset_suntime_minutes: state => state.user.sunset_suntime_minutes,
            sky_ofs: state => state.user.sky_ofs,
        }),
    },
    data() {
        return {
            control: {
                text: '',
                value: false
            },
            fotocelda: {
                text: '',
                value: false
            },
            suntime: false,
            schedule: {
                menu: false,
                minutes: null,
                hours: null,
                type: ''
            },
            on_schedule: {
                minutes: '',
                hours: '',
                status: false,
                text: '',
                msg: ''
            },
            off_schedule: {
                minutes: '',
                hours: '',
                status: false,
                text: '',
                msg: ''
            },
            loading: false,
            error: {
                active: false,
                message: ''
            },
            openUp: false,
            open1: false,
            open2: false,
            open3: false,
            open4: false,
            open5: false,
            msg: '',
            textSuntime: '',
            statusBtn: false,
            current_on_schedule: '',
            current_off_schedule: ''
        }
    },
    methods:{
        ...mapActions({ 
            controlMeter: 'meters/controlMeter',
            scheduleMeter: 'meters/scheduleMeter',
            activeSuntime: 'meters/activeSuntime' 
        }),
        async init(){
            this.suntime = this.meter.suntime
            this.control.value = this.meter.control
            this.control.text = this.control.value ? 'On' : 'Off'
            this.fotocelda.value = this.meter.fotocelda
            this.fotocelda.text = this.fotocelda.value ? 'On' : 'Off'
            this.textSuntime = this.suntime ? 'Solar' : 'Manual'
            this.checkSchedule()
            this.on_schedule.status = (this.on_schedule.hours && this.on_schedule.minutes) ? true : false
            this.off_schedule.status = (this.off_schedule.hours && this.off_schedule.minutes) ? true : false
            this.on_schedule.text = this.on_schedule.status ? 'On' : 'Off'
            this.off_schedule.text = this.off_schedule.status ? 'On' : 'Off'
        },
        checkSchedule(){
            this.suntime = this.meter.suntime
            if(this.meter.schedule){
                const on_time = this.meter.schedule.ON ? this.meter.schedule.ON.split(':').map( t => parseInt(t)): null
                const off_time = this.meter.schedule.OFF ? this.meter.schedule.OFF.split(':').map( t => parseInt(t)): null
                if(on_time){
                    this.on_schedule.hours = ("0" + on_time[0]).slice(-2)
                    this.on_schedule.minutes = ("0" + on_time[1]).slice(-2)
                }
                if(off_time){
                    this.off_schedule.hours = ("0" + off_time[0]).slice(-2)
                    this.off_schedule.minutes = ("0" + off_time[1]).slice(-2)
                }
                this.convertSchedule(this.on_schedule.hours, this.off_schedule.hours)
            }
        },
        async sendCommand(type){
            try {
                this[type].value = !this[type].value
                this.loading = true
                this[type].text = this[type].value ? 'Activating...' : 'Deactivating...'
                await this.controlMeter({
                    meter: this.meter.name,
                    control: this.control.value,
                    fotocelda: this.fotocelda.value
                })
                this.loading = false
                this[type].text = this[type].value ? 'On' : 'Off'
            } catch (error) {
                this[type].value = !this.control.value
                this[type].text = this.control.value ? 'ON Schedule' : 'OFF Schedule'
                this.error.message = 'Error on instruccion'
                this.error.active = true
                this.loading = false
            }
            this.open1=false
            this.open2=false       
        },
        async sendSchedule(type){
            let hh = this.schedule.hours
            let mm = this.schedule.minutes
            try {
                this.loading = true
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        hours: hh,
                        minutes: mm,
                        control: type === 'on' ? 'ON': 'OFF',
                        timezone: this.sky_ofs
                    }  
                })
                if (type === 'on'){
                    this.on_schedule.hours = ("0" + this.schedule.hours).slice(-2)
                    this.on_schedule.minutes = ("0" + this.schedule.minutes).slice(-2)
                    this.on_schedule.status = true
                    this.on_schedule.text = 'On'
                } else {
                    this.off_schedule.hours = ("0" + this.schedule.hours).slice(-2)
                    this.off_schedule.minutes = ("0" + this.schedule.minutes).slice(-2)
                    this.off_schedule.status = true
                    this.off_schedule.text = 'On'
                }
                this.closeMenuSchedule()
                this.dialogControlClose()
                this.loading = false
            } catch (error) {
                console.log(error)
                this.error.message = 'Error on instruction'
                this.error.active = true
                this.loading = false
            }
        },
        async sendScheduleSun(sunStatus){
            try {
                this.loading = true
                this.textSuntime = sunStatus ? 'Manual' : 'Solar'
                this.suntime = !sunStatus
                this.meter.suntime = this.suntime
                let active = this.meter.suntime
                await this.activeSuntime({
                    meter: this.meter.name,
                    data: { active }
                })
                this.loading = false
            } catch (error) {
                this.error.message = 'Error on instruction'
                this.error.active = true
                this.loading = false
            }
            this.dialog5c()
        },
        convertSchedule(on_hours, off_hours){
            if(on_hours){ 
                let on_schedule = Number(on_hours)
                on_schedule += this.sky_ofs
                if (on_schedule < 0) {
                    on_schedule += 24 
                }
                on_schedule = ("0" + (on_schedule)).slice(-2)
                this.on_schedule.hours = on_schedule
            } else {
                this.on_schedule.msg = 'Click to configure ON schedule'
            }
            if(off_hours){
                let off_schedule = Number(off_hours)
                off_schedule += this.sky_ofs
                if (off_schedule < 0) {
                    off_schedule += 24 
                }
                off_schedule = ("0" + (off_schedule)).slice(-2)
                this.off_schedule.hours = off_schedule
            } else {
                this.off_schedule.msg = 'Click to configure OFF schedule'
            }
        },
        changeControlSchedule(type){
            this.dialog3o()
        },
        changeControlSchedule1(type){
            this.dialog4o()
        },
        async confirmChangeON(){
            this.on_schedule.status = !this.on_schedule.status
            this.schedule.hours = this.on_schedule.hours
            this.current_on_schedule = this.schedule.hours
            this.schedule.minutes = this.on_schedule.minutes
            if(this.on_schedule.status) {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        hours: this.schedule.hours,
                        minutes: this.schedule.minutes,
                        control: "ON",
                        timezone: this.sky_ofs
                    }  
                })
            } else {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        control: "ON",
                        inactive: true
                    }
                })
            }
            this.dialog3c()
            this.schedule.type = ''
            this.on_schedule.text = this.on_schedule.status ? 'On' : 'Off'
        },
        async confirmChangeOFF(){
            this.off_schedule.status = !this.off_schedule.status
            this.schedule.hours = this.off_schedule.hours
            this.current_off_schedule = this.schedule.hours
            this.schedule.minutes = this.off_schedule.minutes
            if(this.off_schedule.status) {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        hours: this.off_schedule.hours,
                        minutes: this.off_schedule.minutes,
                        control: "OFF",
                        timezone: this.sky_ofs
                    }  
                })
            } else {
                await this.scheduleMeter({
                    meter: this.meter.name,
                    data: {
                        control: "OFF",
                        inactive: true
                    }
                })
            }
            this.dialog4c()
            this.schedule.type = ''
            this.off_schedule.text = this.off_schedule.status ? 'On' : 'Off'
        },
        dialogControlOpen(){
            this.openUp = true
        },
        dialogControlClose(){
            this.openUp = false
        },
        dialog1o(){
            this.msg = this.control.value ? 'deactivate' : 'activate'
            this.open1 = true
        },
        dialog1c(){
            this.open1 = false
        },
        dialog2o(){
            this.msg = this.fotocelda.value ? 'deactivate' : 'activate'
            this.open2 = true
        },
        dialog2c(){
            this.open2 = false
        },
        dialog3o(){
            this.msg = this.on_schedule.status ? 'deactivate' : 'activate'
            this.open3 = true
        },
        dialog3c(){
            this.open3 = false
        },
        dialog4o(){
            this.msg = this.off_schedule.status ? 'deactivate' : 'activate'
            this.open4 = true
        },
        dialog4c(){
            this.open4 = false
        },
        dialog5o(){
            this.msg = this.suntime ? 'deactivate' : 'activate'
            this.open5 = true
        },
        dialog5c(){
            this.open5 = false
        },
        openMenuSchedule(type){
            if (this.suntime) return
            this.schedule.type = type
            this.schedule.hours = parseInt(this[type + '_schedule'].hours)
            this.schedule.minutes = parseInt(this[type + '_schedule'].minutes)
            this.schedule.menu = true
        },
        cancelSchedule(){
            this.closeMenuSchedule()
        },
        closeMenuSchedule(){
            this.schedule.type = ''
            this.schedule.hours = null
            this.schedule.minutes = null
            this.schedule.menu = false
        },
    },
    watch:{
        meter(){
            this.init()
        }
    },
    created() {
        this.init()
    },
}
</script>